import { z } from 'zod';
import { Role } from '@/types/gql.generated';
import { emailAsArray } from '../lib/collaboratorForm.lib';

const isValidEmail = (email: unknown) =>
  z.string().email().safeParse(email).success;

export const AddCollaboratorSchema = z.object({
  email: z
    .string({ message: 'Email address is required' })
    .trim()
    .min(1, { message: 'Email address is required' })
    .superRefine((value, ctx) => {
      const invalidEmails = emailAsArray(value).filter(
        (email) => !isValidEmail(email)
      );

      if (invalidEmails.length > 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message:
            invalidEmails.length === 1
              ? `${invalidEmails[0]} is not a valid email address`
              : `${invalidEmails.join(', ')} are not valid email addresses`,
          params: { actualValue: value },
        });
      }
    }),
  message: z.string().optional(),
  role: z.nativeEnum(Role).default(Role.Editor),
});

export type AddCollaboratorDto = z.infer<typeof AddCollaboratorSchema>;
